<template>
  <div class="row  p-0 m-0" style="min-height: 90vh;">
    <div class="col-12 d-lg-none mb-4 pb-3 py-3 position-absolute z-3 filtroMovil bg-white">
      <div class="row m-0">
        <div class="col-6 p-0">
          <a class="text-center mb-0 fw-bold nav-link" data-bs-toggle="collapse" href="#collapseExample" role="button"
            aria-expanded="false" aria-controls="collapseExample" style="color:#205760; font-size: 1.1rem;">Filtros
            <span style="background-color: #fa8e00;" class="rounded-5 px-2">{{numeroFiltros}}</span></a>
        </div>
        <div class="col-6 p-0">
          <p class="text-center mb-0 fw-bold" @click="PasarDatos" style="color:#205760; font-size: 1.1rem;">Ver lista</p>
        </div>
        <div class="collapse" id="collapseExample">
          <filtros-component vista='mapa' :numeroFiltros="numeroFiltros" ref="refFiltro" v-if="this.screenWidth < 992" @limpiarFiltro="limpiarFiltro" @getDataCar="getDataCar" @PasarDatos="PasarDatos" @getDataAncho="getDataAncho" @getDataAlto="getDataAlto" @getDataServicio="getDataServicio" @getDataPrecio="getDataPrecio" @getDataHoras="getDataHoras" @getDataDias="getDataDias" @getDataBrowser="getDataBrowser" ></filtros-component>
        </div>
      </div>
    </div>
    <div id="contenedor" class="oculto position-absolute z-3 d-none d-lg-block pt-3">
      <div id="contenedor1" >
        <div v-for="(item, id) in this.plazas.values()" :key="id" class="row m-0 rounded-5 plazaItem overflow-hidden mb-4">
          <a class="col-4 p-0 d-md-block d-none rounded-start-5" style="height: 130px;" :href="'/parking_lot/' + item.id">
            <img :src=item.preview class="w-100" style="max-height: 180px;">
          </a>
          <div class="col-md-8 ">
            <div class="row align-items-center">
              <p class="fw-bold mb-1 textoPrimario">{{item.direccion}}</p>
              <div class="col-4">
                <p class="mb-1 fw-semibold textoPrimario">Horario</p>
                <p class="mb-0">
                  {{formatTime(item.horas.startTime)}} - {{formatTime(item.horas.endTime)}}
                </p>
              </div>
              <div class="col-5">
                <p class="mb-1 fw-semibold textoPrimario">Tamaño</p>
                <p class="mb-0" style="color: #888888;"><img src="./../assets/iconoAltura.png" height="20">{{item.ancho}} x {{item.largo}} cm</p>
              </div>
              <span @click="this.Fav(item.id)" v-if="favoritos.includes(item.id)" class="fas fa-star col-3 text-end star favorito" ></span>
              <span @click="this.Fav(item.id)" v-else class="fas fa-star star text-end col-3" ></span>
            </div>
            <div class="row">
              <div class="col-7">
                <p class="fw-semibold mb-1 mt-2" style="color: #133C44;">Servicios</p>
                <div class="mx-auto" style="display: flex; justify-content: center;">
                  <img v-if="item.servicios.security" class="iconoMap p-1" src="./../assets/iconoSeguridad.png">
                  <img v-if="item.servicios.disabled_people_service" class="iconoMap p-1" src="./../assets/iconoAccesoAdaptado.png">
                  <img v-if="item.servicios.no_columns" class="iconoMap p-1" src="./../assets/iconoColumns.png">
                </div>
              </div>
              <div class="col-5 p-2" style="background-color: #CFE2E4;">
                <p class="fw-semibold mb-0 " style="color: #133C44;">Precio</p>
                <p class="fw-bold mb-0 fs-3 text-center" style="color: #000000;">{{item.precio}}€</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button @click="MostrarPlazas" class="btn bg-white p-2 position-absolute z-2 d-none d-lg-block botonLista" id="mostrarDiv">
      <img src="./../assets/iconoDespliegueLista.png">
    </button>
    <button @click="OcultarPlazas" class="btn bg-white p-2 position-absolute z-2 d-none d-lg-block botonOcultarLista" id="ocultarDiv">
      <img src="./../assets/iconoDespliegueLista.png" style="transform: rotate(180deg);">
    </button>
    <a @click="UbicacionUsuario" class="btn bg-white p-2 position-absolute z-2 botonUbicacion">
      <img src="./../assets/iconoUbicacion.png">
    </a>
    <router-link to="/favorites" class="btn bg-white p-2 position-absolute z-2 botonFavs">
      <span class="fas fa-star text-center w-100 star favorito" style="font-size: 30px;" ></span>
    </router-link>
    <filtros-component vista='mapa' :numeroFiltros="numeroFiltros" v-if="this.screenWidth >= 992" ref="refFiltro" @limpiarFiltro="limpiarFiltro" class="d-none d-lg-block position-absolute z-3 filtroCaja rounded-5" style=" margin-left: 4%; padding-left: 5px; max-height: 86vh; overflow-y: scroll;" @PasarDatos="PasarDatos" @getDataCar="getDataCar" @getDataAncho="getDataAncho" @getDataAlto="getDataAlto" @getDataServicio="getDataServicio" @getDataPrecio="getDataPrecio" @getDataHoras="getDataHoras" @getDataDias="getDataDias" @getDataBrowser="getDataBrowser"></filtros-component>
    <div id="map" class="position-absolute z-1" style="height: 91%;">
    </div>
    <spinner-component id="spinner" class="d-none"></spinner-component>
  </div>
</template>

<script>
import L from 'leaflet';
import axios from 'axios';
import 'leaflet.markercluster';
import FiltrosComponent from '../components/FiltrosComponent.vue'
import { mapState } from 'vuex';
import router from '@/router';
import SpinnerComponent from '../components/SpinnerComponent.vue'

export default {
  name: 'VistaMapa',
  data: function() {
        return {
          map: {},
          markers: L.markerClusterGroup(),
          favoritos: JSON.parse(localStorage.getItem('favoritos')) != null ? JSON.parse(localStorage.getItem('favoritos')) : [],
          filtro:{
            inputValue: "",
            centro: null,
            horas: null,
            isCoche: true,
            precio: 200,
            disponibilidad:[false, false, false, false, false, false, false],
            servicios: {
              security: false,
              disabled_people_service: false,
              no_columns: false
            },
            ancho: null,
            alto: null,
          },
          plazas: new Map(),
          screenWidth: window.innerWidth,
          llamadaDoble: false,
          numeroFiltros: 0
        }
  },
  computed:{
      ...mapState(['isCar']),
      ...mapState(['direccion']),
      ...mapState(['coordenadas']),
      ...mapState(['horasHome']),
      ...mapState(['filtroStore']),
      ...mapState(['token']),
  },
  components:{
    FiltrosComponent,
    SpinnerComponent
  },
  async mounted() {
    this.map = L.map('map', {zoomControl: true,zoom:1,zoomAnimation:false,fadeAnimation:true,markerZoomAnimation:true}).setView([39.850931195377946, -3.1256103515625004], 7)

    this.map.on("moveend", () => {
      this.actualizarResultados()
    });

    if(this.filtroStore != null){
      this.llamadaDoble = true
      this.filtro = this.filtroStore
      if(typeof this.filtro.horas == 'string'){
        this.filtro.horas = JSON.parse(this.filtro.horas)
      }
      this.$store.dispatch('limpiar')
      this.$refs.refFiltro.MeterDatos(this.filtro)
      if(this.filtro.centro != null){
        this.map.setView([this.filtro.centro[1], this.filtro.centro[0]], 15)
      }
    }else{
      if(this.coordenadas != null){
        this.DatosHome()
        this.map.setView([this.coordenadas[1], this.coordenadas[0]], 15)
      }
    }
    
    // Agregar una capa de mapa base
    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      maxZoom: 20,
      minZoom: 6
    }).addTo(this.map);
    
    this.map.addLayer(this.markers);

    this.actualizarResultados()

  },
  methods:{
    getFilter() {
      let filtro = ""; 
      /*inputValue: "",
            centro: null,
            horas: null,
            isCoche: true,
            precio: 100,
            disponibilidad:[false, false, false, false, false, false, false],
            servicios: {
              aseo: false,
              vigilancia: false,
              abierto24h: false
            },
            ancho: null,
            alto: null,
          },*/
      filtro += this.filtro.isCoche ? "&vehicle_type=car" : "&vehicle_type=motorbike"
      filtro += this.filtro.ancho !== null && this.filtro.ancho !== "" ? ("&min_width=" + this.filtro.ancho) : "" 
      filtro += this.filtro.alto !== null && this.filtro.alto !== "" ? ("&min_height=" + this.filtro.alto) : ""
      
      filtro += "&max_monthly_price="+ this.filtro.precio

      let days = []
      
      if (this.filtro.disponibilidad[0]){ days.push("mon") }
      if (this.filtro.disponibilidad[1]){ days.push("tue") }
      if (this.filtro.disponibilidad[2]){ days.push("wed") }
      if (this.filtro.disponibilidad[3]){ days.push("thu") }
      if (this.filtro.disponibilidad[4]){ days.push("fri") }
      if (this.filtro.disponibilidad[5]){ days.push("sat") }
      if (this.filtro.disponibilidad[6]){ days.push("sun") }

      if (days.length > 0) {
        filtro += "&availability=" + days.toString()
      }

      if(this.filtro.horas != null){
        if(this.filtro.horas.startTime != ''){
          filtro += "&start_hour=" + this.filtro.horas.startTime.split(":")[0]
          filtro += "&start_minute=" + this.filtro.horas.startTime.split(":")[1]
        }
        if(this.filtro.horas.endTime != ''){
          filtro += "&end_hour=" + this.filtro.horas.endTime.split(":")[0]
          filtro += "&end_minute=" + this.filtro.horas.endTime.split(":")[1]
        }
      }

      filtro += this.filtro.servicios.security ? "&security_service=true" : ""
      filtro += this.filtro.servicios.disabled_people_service ? "&disabled_people_service=true" : ""
      filtro += this.filtro.servicios.no_columns ? "&no_columns_service=true" : ""
      return filtro
    },

    plazaOldMapper(plaza) {
      
      return  {
        id: plaza.id,
        direccion:plaza.direction,
        coordenadas: {
          latitud: plaza.coordinates.latitude,
          longitud: plaza.coordinates.longitude
        },
        isCoche: (plaza.vehicle_type == "car"),
        horas: {
          startTime: plaza.start_hour + ":" + plaza.start_minute,
          endTime: plaza.end_hour + ":" + plaza.end_minute
        },
        disponibilidad: [plaza.availability.monday,
        plaza.availability.tuesday, plaza.availability.wednesday, plaza.availability.thursday,
        plaza.availability.friday, plaza.availability.saturday, plaza.availability.sunday],
        largo: plaza.height,
        ancho: plaza.width,
        servicios: plaza.services,
        precio: plaza.monthly_price,
        preview: plaza.preview != null ? plaza.preview : "https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg"
        
      }
    },
    MeterMarcador(plaza){
      var divIcon = L.divIcon({
          // Establece el contenido HTML del icono
          html: '<div class="marcador"><p>'+ plaza.precio +'€</p></div><div class="flecha-down mx-auto"></div>',
          iconSize: [38, 40], // size of the icon
          shadowSize: [50, 64], // size of the shadow
          iconAnchor: [22, 40], // point of the icon which will correspond to marker's location
          popupAnchor: [-3, -76]
        });
      var marker = L.marker([plaza.coordenadas.latitud, plaza.coordenadas.longitud], {icon : divIcon});
      this.markers.addLayer(marker);

      var vm = this

      var starIcon = document.createElement('span');
      starIcon.className = 'fas fa-star star';
      starIcon.id = 'star'+ plaza.id
      if(this.favoritos.includes(plaza.id)){
        starIcon.classList.add("favorito")
      }
      starIcon.addEventListener('click', function () {
        if(starIcon.classList.contains("favorito")){
          vm.CambiarFav(plaza.id)
        }else{
          vm.CambiarFav(plaza.id)
        }
        starIcon.classList.toggle('favorito');
      });
      starIcon.style.width= "100%"
      starIcon.style.height = "auto"

      marker.on('popupopen', function(){
        if (vm.favoritos.includes(plaza.id)) {
          if (!starIcon.classList.contains("favorito")) {
            starIcon.classList.add('favorito');
          }
        } else {
          if (starIcon.classList.contains("favorito")) {
            starIcon.classList.remove('favorito');
          }
        }
      });

      let horasFormat = {
        start_hour: (plaza.horas.startTime.split(":")[0].length < 2 ? "0" : "") + plaza.horas.startTime.split(":")[0],
        start_minute: (plaza.horas.startTime.split(":")[1].length < 2 ? "0" : "") + plaza.horas.startTime.split(":")[1],
        end_hour: (plaza.horas.endTime.split(":")[0].length < 2 ? "0" : "") + plaza.horas.endTime.split(":")[0],
        end_minute: (plaza.horas.endTime.split(":")[1].length < 2 ? "0" : "") + plaza.horas.endTime.split(":")[1],
      }
      
      var stringPopup = '\
      <div class="row p-3 pb-0" style="width:350px">\
        <div class="row m-0">\
          <h6 class="fw-bold textoPrimario col-10">' + plaza.direccion +'</h6>\
          <div class="col-2 d-flex align-items-center justify-content" id="aqui">\
          </div>\
        </div>\
        <hr class="mt-1 text-warning">\
        <div class="row m-0 p-0">\
          <div class="col-6">\
            <p class="fw-bold textoPrimario textPopUp text-center my-1">Horario</p>\
            <p class="textPopUp text-center my-2">' + horasFormat.start_hour + ":" + horasFormat.start_minute + ' - ' + horasFormat.end_hour + ":" + horasFormat.end_minute +'</p>\
          </div>\
          <div class="col-6">\
            <p class="fw-bold textoPrimario textPopUp text-center my-1">Tamaño</p>\
            <p class="textPopUp text-center my-2"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADXElEQVR4nO3dTW7TQBjGcR+Di9ATsGBDWfBVvtJ21Z4MsfX7vJMV4gjAEjgKTVo0VipBMnZce5w8mTx/yRJtkeXml/G4VTVTVQUE4Cwe+74OVVVV7X4BD4t4xH/rRdljZuESHpbwcBcPg9+ahWuh7G9kLO8x/kNxvxIKAQaEwocBoez4acqbCfyu57EEcL7DSzyegDBLjIzUSNn8PwizfV9/cSPD4DcbtyQL1xu3qrUnL42UzJmFN+sY8QW//5ljHSR+rnZ/m7i1aaRMhYF/5oUUSMd8s9Dta2C1++ttGF0g9yiJcyzM/ePQ6zrK6p4Y20CarwtlEoxF2+PrNhChTIIRWh9b+4B0zEcLd/8w5pqLzd1fPRTjISAxoYzEsB6T70NAukahRkoGjCEgMaG0BMxfjn23YgBIFwowf18dYzkwxoB0z1tHhpILYyxI7OhRcmLkAOmcx0J4V5WchfDC4H9y3iKQAaTrjVIsSu3+PPEr9Js4uY45LzKBtE30zcfAaVVaBv+1/o3GW8XY8yIjSOvtC/6zKi3z8CM3xhQgKRRD+F6VFoCT+I3Fd5vZ/Fm283p+kOa8wGkzquHfzOaPc523+DARiBJIGUEjhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIhCsIZFju/gjun+H+xd2fsIPUcQU8D7+bdb6Ak6q0gPBJC5gRZQhftcQfUe7+9FAXwbSMK+AdxDKxYxbCRyaQtrV7435WVcnlRoEWUh7fatHiLCiYaKnxYhdQZl6Mv27ZIeHoMLYu7+39d1EbCqLtKiZCwQAQYUy0/9QQEO1D1TNtCnZQKDgfO0LaNpjUZmAZd/nsCyIMsq1XkdikWPvhToSCDhBhZK5O/7Lv1tyvtoHE/dYTG91rZIzNEnvYNigWrttAzMJlCkN7qe8ABWsgwthRQJgl3vXrH6c+t9TImAwFqSemrqP1cVntHmUpDB6UpTB2XJ1+rN14LFZ7RDFh0KAsVn+QcLHv61HVak4Bzkp4Mf4CyRSDOl0uWtAAAAAASUVORK5CYII=" height="20">' + plaza.ancho + ' x '+ plaza.largo + 'cm</p>\
          </div>\
          <div>\
            <p class="fw-bold textoPrimario textPopUp text-center my-1">Servicios</p>\
            <div class="col-9 mx-auto" style="display: flex; justify-content: center;">'
    if(plaza.servicios.security){
      stringPopup += '<img class="iconoPop p-1 mx-auto" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAI3UlEQVR4nO2da6wkRRXHS1QQH4AoKgFERWV9BPDJSzG+SXwgIioR5Quiq0aCGIgfYAQCbHyggMl6RYEQjKR1ps//373NXVa9moAuLwWENYqygIKQLCLurrALyzWnby/M1O3p7pnbPdM9U7+kkpvcmepTfbqr6rxqjHE4HA6Hw+FwOBwOh8PhmCgAHA7gRwL8Schb9W8/DA8at1xThx8EHwT5W5DzKe0JAKeNW8aJp9Vq7SBB8AkBbu6jiJ7mk58at8wTyczMzLMlCD4HYF0RRWxvAtyj3x23/BMDyecK+VW9sTk3/jcAjgJwEsgt3f8j+dlxj6PxiMgLRORkkPfnvAVrfN8/rOe75I97PgOs06lufKNpMFEU7QHgmyAfzlDCNiEDEXlrWh+dTme/eFHvVcpRox9NgwnDcF8AFwqwOUMRWwS4QkT2z+sPpGcp5PrRjKThAHi1kDMgt2YoYqMqqx1FexftNwiCAwV40lLKe6odTYPxw/AgfdoXTS29bYNOX97s7O7DXEPIq+31pvyRNByS79D5P3PHRD4QK8Lzdl3KtUTkCLtvkoeaaWd+fv4ZPvkRIX+fo4i7dGc1Nzf3nLKuLeS11rTVMdNKq9XaIVZEjlWt/ic1+ubm5p5VtgwAPmzZK08CeIOZJjzP2zGxqv+So4hrVWH6BlUli/YN8g/WdS8304Dnec/XKUeAf+YpQkTeNyq5ABxnybDV9/1XmEmF5ItjYw54KM+YI/m2Ucvned4zBfir9VBcbCYNAC8VcoUAm/KMOZLLximrT37BWksebbfbe5pJIAzDVyVW9aMZzr5N+hnf9/cxNSCKop1A3me9JeeZJgPggNh1ATyeoYhHVBFhGL7M1AySX7dl9X1/N9NUY05sV0Rve7AMY65KVq9e/bzY+u+1S75hGqUI4JdZOyaQ63Vn5XnezqYBCHm2/SDVWvbW08bcDZlbV00oqMiYq5JOp/Oi2FnZu5Z82dTVmBPgzzmKuBnAsVUac1Uj5Pescd2r4zd1mVeTyNy9RaxqMwGoG98O8+rDOFahoijaJbGq/5VnzHWC4O1mwrDDvDozjCXMq8YQgG+B/G+WMQfg0iKRuabSWbXqtWMN8ybG3MocY25znYy5qkkJ8/608osGQfBGAFdmGXNxQgFwjiYYmClCRD5kKeSPlV0MwCEgkWXMxesHcJquJ2YKEfJce+NS+kUAvF/IX+XsmO4CsLzMyFxT0IUbwMdB3phyX8rzbWn8ONeYI28HcHzTjLky0HRSACdkpKI+XJr3N7EjtmUoY63uIJpszA2LukUAfEWAuzPuz8bSAmZJZkWqMoS8ZlpzkTzP21Udh7HTs/8aqutrGATBa0q7MIDZFGOuPY7IXB1ot9svSRbr/2S8EWp//EyT6UoXYJFdARxpphCSLxfyoqxUVAEeA3CJZktWFiu2p6s6BoaqRL0JQl6WlYqaRC8vCIJgL1M1i3YNTQq4LAGSbwbw88zNjCZdAGepy92MCiHPbFTAZYmQfFfKumm3+zVcqzUmZtRoTNhewGoZcFkiui0Fed1IopdxgYkuNmovLFiQa5KnwIv9UJqur1ke5AoAZwA4neSX4vIt4JMplvn6Sair8zSfSuTTAtxSIHr5mVIMXs1XEuDfOZofuDW5ri6Kop188kQh78wZ520i8tFSDV4AV5WtjGTaur1plrmnqajkKXmpqF1jvKx0IQYt8x2oNaSuzpud3T3ZnGzImJY0a/16SyF3li6MAH5aIrImEiTtpKSdri1O3VxoM0kpmJe0NSnZ5mtNjWm323sK8O2c6KWeyHCVVlyFYfhCS0mbSheK5DGWAFvV6hyyr2X2vlxE3m1qRvh09PKxnDDyJd1+Jp3SKldI4p9fV1ZmtvqxrL6uMTUhKBa93NjPqib5AXudrETQuLilV6j/aWb5MH1phsii+bdPPfeoQIHoZddTf7c6CPskS6+11sgLKxFY989xFK9X+yuG7c+2SwT4RbkSF0PXwtzoJXCP/cbEsQvgOF3sdZpK3oxeZZDbOmH4OlMVQn7REuoRXcSG6ct+tVX4UdVntBZO6zk6L3qp07TODEkk7/whdpAXVDoQjW/b9QtqlQ/bH4CbrL4uNaM4rYe8I+eNuEFj2t1JaZrGCYBFlaHJeyPxRAA41br4Bk31HLKvY+1dSxX5Vp7n7Ry7ccj1OTfy15qAkdGPKuW7OQcJbNFEhJHlBCTbuh7jSMivlVVXB/L7ZckaRdEuiV30QMbboIs4dFEv2q+WLKckQ+t9OBvAK82osd3pmjs1bLpOcnZUd1+bl5oMxwEKPP0wfMuw17H7NONCF/K4LKxLGC1YHKYv3SraydT6pA3Tl+/7++gbViBEulINP7NEaqMQJXaz9w7078PMmyLypkWhTeChQQI3YYECz+2n9ZQZIq2VQtQojI3D3ht5/CB9JIbUbX22jKcWLfBEhaf1NEYhirpPlnJMnZDfyZha+q5LLFDgWdZpPY1SSDJn21U+Rxf87mE5T7a6Uz4/aIGnVHBaT2MUooD8iSXYjQW3zn+z3q5/JK56O/58hIY+NQ0/UxHALXr+rW6lRzPymiok7TBHdYtkfQfAD1MCO0fGx2Bkn2c4P47TehqlkLQQr55Pm3X0dso5gz/Y/n8hWwUVcbUfBO80Y6S2CulzmOPhfeyXnli0WurdrhfdOifJZWmK2KaRR90qmxpQW4UoixxvwKqUz1xpDeKJtPMFdfrRKGUSOtZt8XW6I9MiSFMjaq0QETnYFrDbLUHyYynTTqNPukGdFaLE3tJeIb2nToK2aiA0tNn0cjXUXSEk32vP+SLyejuGniQHHGAaDuquEMU+ZjXFvT4x2e+wUoMGOdV6ZKhNkGPA/W6UxluVpCQ0rKqdUnSHFP/GUroyNpdaKzdmNIN/ECO2rFZGaHb7E7TcTBCeHhdV8GeNxqoQJS5JSNzzmr2nxSlmAmkvHJRzU+0VoiT5Ssv0J4HMBDOzkCa0PCnW2VhbhTgcDofD4XA4HA6Hw+FwOBwOh8PhcDgcDtN8/g8ewOQmJsLY8gAAAABJRU5ErkJggg==">'
    }
    if(plaza.servicios.disabled_people_service){
      stringPopup += '<img class="iconoPop p-1 mx-auto" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFb0lEQVR4nO1dWW8iRxDmIdEmPzHZjfZXJVk/5HWT9UumGhvsXduwMb4g2MYrxxd4Fx8yOGBMQPIBdkcfWiTm4Bh7ZroZ6pNKQsOAu+rrruqqajORCIPBYDAYDAaDwWAwGAwGg+EC09PT3xPRKxJimogODKImCSHDJAZ0gm5CvDOi0ZeJROI7LSYJEb0molPVBqLg5UQI8ZMyw09NTX1rCDGlgSGkUiF6A1sETgAR/apceaGN/Ba08V9roLTUSoheBWJ8BB/4P+UKC73EIDrDZsR3Ar7udpQrTBrKn0L86D8B2GpqoCzpKER/BEFAPkilMpmMrFSrst1ud6RSqch0JqMrAQe+ExBkklUoFGQ/5AsF9Qa3S8N3AoKc+cOQTqdVG9wmoSGgWq0OJQDuSLXBQ0tAu90eSkCr1VJu8NAS0Gq1mACVBFQqlaEE/MsuyD8C0iME4Q0Owv6ugvyAbehRPq/c34c6BlB3JaTTHVfTTcTwWseZH1oCaMyECRBMwOTWgkTIVkBh/GpB4SEgw7UgtQRUuRakloA214LUEjAqghrPqBLxG0yAYAJ6oXrG8woQ6o3OLkioN3woYsDc/LzczuXk6emp9Aq3t7ednIIJGGD45VRKXpRK8vHxUfqBm5sbJsDJ8PPv33s625kAl3X+1gh9Xy+MH2TxbixiwM6nT33dTaPRkHt7eyMbWHXQHTsC/ulj3Kurq04s6N7HBPhAwNr6um3mPzw8yFwuJ0U0arqXCfCYgA8LC/Lu/t5k1/v7e5laWXG8nwnwmIDz83PbzP9rebnv/X4AQf/4+Ni22kIfAxLJpM315HZ2Bn7Gzx1SqVyeLAIuLi5MBkCzxYuTcc/B4uLiZBAQn5uzzf6V1VVPTsbpuAq0I2Bre9ukeL1e9+RknBdY39gIPwEnJycmpQ8PD590Mu7RhzpRs9mU0ZmZcBNQu7527X7omYJ8oxfX9br8Uiw6krC7uxtuAu7u7kwKL/gU/KhHlpaWbPWgeDxuGwuA3RaKgqElAPv9XszMzvpOwGwsZvqbGAOub1viURdwkxNDAIyjigARjXZqTk4YlBSONQHWZe/X/pt6ZNHigjCG7nvJjx8dAzpilRcZsnYEqAjCq2trZuPWaqb3jz9/dlwFm1tb4SPgxNLxOjo68p2Ao3x+oI+PxeOdXrEVuAb3hZWQzWY7GXyxWHQVpLVPxNBw8ZuARrM5dGZvbm46rgIY/b9Gw3Tt9OxsfAnASQdbKaJPCZo8ELg4awDGGJzuxf8djAJUcseWAEipVDIpdGXxyeShWGMOZrSbKq2TW0omk+NNAJouVqALRh4bH71mK3rbnG7qTTidjXiFeOFmDFoSACmXyzbXkPLQFcH1WHMOnDUa9jkEXWTKXWBF4KjMU7NjbQlACcLaZLkb0JJ0ZfyVFVu7E38LbdBRPv93Ntv5zOXlZcctPWcs2hIAyTrsPB7QlB/SHRvmdqwzH4BR3XwPErTnTgTtCYDsHxw4+txareYqScO91oDbxd7+vifGDCUBg0jo5gkIfshmUVKAj4bgNa4hybLu83uxr9D4Y0MABJlmy8PGO77LrduZaAIgHxYWbDnCU4DdzqgBNwwENLwedOoJx9MReJFkDdvnBykGUd13AgyiQ78UmJuf79RtUDxDUEYZGYaG4DWu4T3c06+8oFj2/SdAiHcaKCp1FEOIt/4TEI2+VK0o6SpEPwTy490GUVG5skIvMYi+xGKxF5EggCdHqFaYJvGHu3vBD3AQvbP/50jQwGM7mASBwPtLIpH4JqIKX58nMHEPdDCIioG7nUGBGYPB7+djLxzWx1gZRHskxO/Y7WjzGCsGg8FgMBgMBoPBYDAYDEZkXPA/ciZhlOPPpjUAAAAASUVORK5CYII=">'
    }
    if(plaza.servicios.no_columns){
      stringPopup += '<img class="iconoPop p-1 mx-auto" src="https://apparca.es/img/iconoColumns.e5a32d8b.png">'
    }
    stringPopup += '</div>\
          </div>\
        </div>\
      </div>\
      <div class="col-12 mb-0" style="background-color: #CFE2E4;">\
        <div>\
          <p class="fw-semibold mb-0 col-4 mx-auto pt-2 textPopUp" style="color: #133C44;">Precio</p>\
          <p class="fw-bold mb-0 fs-3 text-center mt-0" style="color: #000000;">' + plaza.precio + '€</p>\
        </div>\
      </div>\
      <div class="col-12 py-2 text-center" style="background-color: #205760; border-radius: 0px 0px 25px 25px;">\
          <a href="/parking_lot/'+ plaza.id + '" class="fw-semibold text-decoration-none w-100 text-white textPopUp" >Ver detalles</a>\
      </div>';

      var popupContent = document.createElement('div');
      popupContent.innerHTML = stringPopup;
      var aqui = popupContent.querySelector('#aqui');
      aqui.appendChild(starIcon)

      var popup = L.popup({ className: 'popup' })
          .setContent(popupContent);

      marker.bindPopup(popup);
    },
    getDataCar(data) {
      this.filtro.isCoche = data
      if(!this.llamadaDoble){
        this.actualizarFiltro()
      }else{
        this.llamadaDoble = false
      }
    },
    getDataHoras(data) {
      this.filtro.horas = JSON.parse(data)
      this.actualizarFiltro()
    },
    getDataPrecio(data) {
      this.filtro.precio = data
      this.actualizarFiltro()
    },
    getDataBrowser(inputValue, centro, isCorrect){
      this.filtro.inputValue = inputValue
      this.filtro.centro = centro
      this.isCorrect = isCorrect

      if(isCorrect){
        this.map.setView([centro[1], centro[0]], 15)
      }

      this.actualizarFiltro()
    },
    PasarDatos(){
      this.$store.dispatch('PasarDatos', this.filtro)
      router.push({ name: 'VistaLista' });
    },
    UbicacionUsuario(){
      if ("geolocation" in navigator) {
        var vm = this;
        // El navegador admite geolocalización.
        navigator.geolocation.getCurrentPosition(function(position) {
          var latitud = position.coords.latitude;
          var longitud = position.coords.longitude;
          
          vm.map.setView([latitud, longitud], 14)
        }, function() {});
      }
    },
    // Función para formatear la hora
    formatTime(time) {
      const [hours, minutes] = time.split(':');
      const formattedHours = hours.length === 1 ? `0${hours}` : hours;
      const formattedMinutes = minutes.length === 1 ? `0${minutes}` : minutes;
      return `${formattedHours}:${formattedMinutes}`;
    },
    getDataServicio(servicio, value){
      const propiedades = Object.keys(this.filtro.servicios);

      this.filtro.servicios[propiedades[servicio]] = value;
      this.actualizarFiltro()
    },
    getDataAncho(data){
      this.filtro.ancho = data
      this.actualizarFiltro()
    },
    getDataAlto(data){
      this.filtro.alto = data
      this.actualizarFiltro()
    },
    getDataDias(data){
      this.filtro.disponibilidad = data
      this.actualizarFiltro()
    },
    actualizarFiltro(){
      this.markers.clearLayers()
      this.plazas = new Map()
      this.actualizarResultados()
    },
    actualizarNumerofiltros(){
      this.numeroFiltros = 0;
      (this.filtro.inputValue != "") ? this.numeroFiltros++ : undefined;
      (this.filtro.horas != null) ? this.numeroFiltros++ : undefined;
      (this.filtro.isCoche !== true) ? this.numeroFiltros++ : undefined;
      (this.filtro.precio != 100) ? this.numeroFiltros++ : undefined;
      let todosFalse = true;

      for (let i = 0; i < this.filtro.disponibilidad.length; i++) {
        if (this.filtro.disponibilidad[i] !== false) {
          todosFalse = false;
          break; // Sal del bucle tan pronto como encuentres un valor distinto de false
        }
      }
      (!todosFalse) ? this.numeroFiltros++ : undefined;
      (this.filtro.servicios.security != false || this.filtro.servicios.disabled_people_service != false || this.filtro.servicios.no_columns != false) ? this.numeroFiltros++ : undefined;
      (this.filtro.ancho !== null && this.filtro.ancho !== "") ? this.numeroFiltros++ : undefined;
      (this.filtro.alto !== null && this.filtro.alto !== "") ? this.numeroFiltros++ : undefined;
    },
    async actualizarResultados(){
      /*var spinner = document.getElementById("spinner")
      spinner.classList.remove("d-none")*/
            // Assuming you have a Leaflet map object called 'map'
      const mapBounds = this.map.getBounds();
      const southWest = mapBounds.getSouthWest();
      const northEast = mapBounds.getNorthEast();


      const bbox = (southWest.lng + "," + southWest.lat  + "," +  northEast.lng + "," + northEast.lat);

      const response = await axios.get('https://api.apparca.es/v1/api/parking_lots?bbox=' + bbox + this.getFilter());
      const items = response.data.items
      //spinner.classList.add("d-none")
      
      items.forEach((plaza) => {
        if (this.plazas.get(plaza.id) != undefined) {
          return 
        }
        plaza = (this.plazaOldMapper(plaza))
        this.plazas.set(plaza.id, plaza)
        this.MeterMarcador(plaza)
        
      })
      this.actualizarNumerofiltros()
    },
    DatosHome(){
      var data = {
        nombre: this.isCar ? "Coche" : "Moto",
        direccion: this.direccion,
        horas: this.horasHome
      }

      this.$refs.refFiltro.CambiarOptionsHome(data)
      this.filtro.isCoche = this.isCar
      this.filtro.inputValue = this.direccion
      this.filtro.centro = this.coordenadas
      this.filtro.horas = this.horasHome


      this.$store.dispatch('limpiar')
    },
    MostrarPlazas(){
      const contenedorDiv = document.getElementById("contenedor");
      const ocultarDivBtn = document.getElementById("ocultarDiv");
      contenedorDiv.classList.toggle("oculto");
      
      contenedorDiv.style.left = "0";
      
      if(window.innerWidth > 1450){
        ocultarDivBtn.style.left = "60%"
      }
      else if(window.innerWidth > 1200){
        ocultarDivBtn.style.left = "65%"
      }else if(window.innerWidth > 992){
        ocultarDivBtn.style.left = "80%"
      }
    },
    OcultarPlazas(){
      const contenedorDiv = document.getElementById("contenedor");
      const ocultarDivBtn = document.getElementById("ocultarDiv");
      contenedorDiv.classList.toggle("oculto");
      if (contenedorDiv.classList.contains("oculto")) {
          if(window.innerWidth > 1450){
            contenedorDiv.style.left = "-60%";
          }
          else if(window.innerWidth > 1200){
            contenedorDiv.style.left = "-65%";
          }
          else if(window.innerWidth > 992){
            contenedorDiv.style.left = "-80%";
          }
      } else {
          contenedorDiv.style.left = "0";
      }
      ocultarDivBtn.style.left = "-10%"
    },
    limpiarFiltro(){
      this.filtro = {
        inputValue: "",
        latitud: "38.3451700",
        longitud: "-0.4814900",
        horas: null,
        isCoche: true,
        precio: 100,
        disponibilidad:[false, false, false, false, false, false, false],
        servicios: {
          security: false,
          disabled_people_service: false,
          no_columns: false
        },
        ancho: null,
        alto: null,
      }
    },
    CambiarFav(id){
      var indice = this.favoritos.indexOf(id);
      if (indice !== -1) {
        this.favoritos.splice(indice, 1);
        localStorage.setItem('favoritos', JSON.stringify(this.favoritos));
        const apiUrlFavorites = 'https://api.apparca.es/v1/api/favorites/'+ id;
        const headers = {
          Authorization: `Bearer ${this.token}`,
        };
        axios.delete(apiUrlFavorites, { headers })
        .then(() => {
        })
        .catch(error => {
          console.error(error);
        });
      }else{
        this.favoritos.push(id)
        localStorage.setItem('favoritos', JSON.stringify(this.favoritos));
        const apiUrlFavorites = 'https://api.apparca.es/v1/api/favorites';
        const headers = {
          Authorization: `Bearer ${this.token}`,
        };
        let objeto = {
          parking_lots : this.favoritos
        }
        axios.post(apiUrlFavorites, objeto, { headers })
        .then(() => {
        })
        .catch(error => {
          console.error(error);
        });
      }
    },
    Fav(id){
      var elemento = document.getElementById("star"+id)
      if(elemento != null){
        elemento.classList.toggle('favorito');
      }
      this.CambiarFav(id)
    }
  }
}

</script>

<style>
.star{
  font-size: 24px;
  color: rgb(187, 187, 187);
  text-align: center;
}
.favorito{
    color: #fa8e00;
  }

.filtroCaja::-webkit-scrollbar{
        width: 5px;
    }

    .filtroCaja{
      direction: rtl;
    }

    .prueba{
      direction:ltr;
    }

    .filtroCaja::-webkit-scrollbar-thumb {
        background-image: linear-gradient(180deg, #28748165 10%, #9e9e9e 90%);
        box-shadow: inset 2px 2px 5px 0 rgba(#fff, 0.5);
        border-radius: 100px;
    }
  .textoPrimario {
      color: #133C44;
    }

    .textPopUp{
      font-size: 1rem;
    }

    .iconoPop {
      width: 20%;
    }

    .iconoMap {
      width: 20%;
    }

    .marcador p{
      border:0px;
      margin:0px;
      font-weight:600;
      text-align:center;
      font-size: 0.9rem;
      color: white;
    }

    .marcador{
      background-color: #2b7a64;
      padding: 4px;
      width: 55px;
      border-radius: 5px;
    }

    .flecha-down {
        width: 0px;
        height: 0px;
        border-left: 7px solid transparent; /* izquierda flecha */
        border-right: 7px solid transparent; /* derecha flecha */
        border-top: 7px solid #2b7a64; /* base flecha y color*/
        font-size: 0px;
    }

    .leaflet-div-icon{
        width: 55px !important;
        border:0px;
        background-color: transparent;
    }

    .leaflet-popup-content-wrapper{
      margin: 0px;
      border-radius: 25px;
      padding: 0px;
    }

    .leaflet-popup{
      margin-bottom: 5px;
    }

    .leaflet-popup-close-button, .leaflet-popup-tip-container{
      display: none;
    }

    .leaflet-popup-content{
      margin: 0px;
      width: auto !important;
    }

    .filtroCaja{
      width: 22% !important;
    }
    .botonLista{
      width: 40px !important;
      left: 25%;
      top: 250px
    }

    .botonUbicacion{
      width: 60px !important;
      height: 60px !important;
      right: 2%;
      bottom: 4vh
    }

    .botonFavs{
      width: 60px !important;
      height: auto !important;
      right: 2%;
      bottom: 12vh
    }

    @media screen and (max-height: 792px) {
      .botonFavs{
        bottom: 14vh
      }
    }

    @media screen and (max-height: 636px) {
      .botonFavs{
        bottom: 17vh
      }
    }

    @media screen and (max-height: 485px) {
      .botonFavs{
        bottom: 20vh
      }
    }
    
    .botonOcultarLista{
      width: 40px !important;
      left: -10%;
      top: 250px;
      transition: 1s;
    }

    .botonOcultarLista img{
      width: 100%;
      height: auto;
    }

    .botonLista img{
      width: 100%;
      height: auto;
    }

    .botonUbicacion img{
      width: 100%;
      height: auto;
    }

    .listaDesplegable{
      margin-left: 24%;
      height: 90vh;
      width: 200px;
      background-color: white;
    }

    #contenedor {
        left: -60%; /* Comienza fuera de la pantalla */
        width: 60%;
        height: 91vh;
        padding-left: 27%;
        background-color: white;
        overflow: hidden;
        transition: 1s;
    }

    #contenedor1{
      height: 100%;
      overflow-y: scroll;
      padding-right: 20px;
    }

    #contenedor1::-webkit-scrollbar{
        width: 10px;
    }

    #contenedor1::-webkit-scrollbar-thumb {
        background-image: linear-gradient(180deg, #287381 10%, #8cbdc5 90%);
        box-shadow: inset 2px 2px 5px 0 rgba(#fff, 0.5);
        border-radius: 100px;
    }

    @media screen and (max-width: 1450px) {
      .filtroCaja{
        width: 25% !important;
      }
      .botonLista{
        left: 28%;
      }
      #contenedor{
        padding-left: 28%;
        width: 65%;
        left: -65%;
      }
    }

    @media screen and (max-width: 1200px) {
      .filtroCaja{
        width: 30% !important;
      }
      .botonLista{
        left: 32%;
      }
      #contenedor{
        padding-left: 33%;
        width: 80%;
        left: -80%;
      }
    }

</style>